import React, { FC, memo } from 'react';
import classes from '../onboardingCarousel.module.css';
import finger from 'features/selectable_course/static/world_map_finger.png';

const FourthCut: FC = memo(() => {
  return (
    <>
      <div className={classes.blackBorder} style={{ fontSize: '1rem', marginBottom: '6vw' }}>
        まずは好きな地域を選択！
      </div>
      <div className={classes.iidukaFirstWrapper} style={{ width: '82vw' }}>
        <img src={finger} alt="" width="100%"></img>
      </div>
    </>
  );
});

export default FourthCut;
